import { Component, input } from '@angular/core';

import { TimingTowerConfigurableComponent } from './timing-tower-configurable/timing-tower-configurable.component';
import { TIMING_TOWER_FULL_CONFIG } from './timing-tower-configurable/timing-tower-column-config';

/**
 * Full timing tower component with drawer - delegates to the configurable component.
 * This component is maintained for backward compatibility.
 */
@Component({
	selector: 'vb-lxp-timing-tower-full',
	imports: [TimingTowerConfigurableComponent],
	templateUrl: './timing-tower-full.component.html',
	styleUrl: './timing-tower-full.component.css',
})
export class TimingTowerFullComponent {
	public config = TIMING_TOWER_FULL_CONFIG;
	public enableColumnCustomization = input(true);
	public hideColumnSelection = input(true);
	public activeClass = input('');
	public activeNumberClass = input('');
	public selectedClasses = input<string[]>([]);
}
